import { render, staticRenderFns } from "./MlbGameScore.vue?vue&type=template&id=3e0b29a2&scoped=true&"
import script from "./MlbGameScore.vue?vue&type=script&lang=js&"
export * from "./MlbGameScore.vue?vue&type=script&lang=js&"
import style0 from "./MlbGameScore.vue?vue&type=style&index=0&id=3e0b29a2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e0b29a2",
  null
  
)

export default component.exports